// Account page component for the settings page.

// Imports ----------------------------------------------------------------------------------------------------------

import Template from '../../templates/account';

/**
 * Account page component for the settings page.
 * Handles the account information display and CMP integration.
 *
 * @returns {JSX.Element} Account page component
 */
export default function Account() {
  return <Template />;
}
